<template>
    <section class="model-body">
        <div class="form-section">
            <ds-modal
                :is-open="isSequenceModalOpen"
                show-close
                :title.sync="modelTitle"
                @close="isSequenceModalOpen = false"
            >
                <ds-select-field
                    v-model="selectedCampaign"
                    :options="publishedCampaign"
                    bind-value-only
                    class="input-border"
                    name="Select-Campaign"
                    placeholder="Select Campaign"
                    label="Select Campaign"
                    @input="selectedCampaignId"
                />
                <ds-select-field
                    v-model="flowForCampaign"
                    :options="campaignFlows"
                    bind-value-only
                    class="input-border"
                    placeholder="Select flow"
                    label="Select flow"
                >
                    <template #help>
                        Please select a campaign to see available sequences.
                    </template>
                </ds-select-field>

                <div>
                    <ds-filled-button
                        id="save-flow"
                        name="save"
                        :disabled="disableSave"
                        data-qa="save-flow"
                        @click="save"
                    >
                        Save
                    </ds-filled-button>

                    <span class="button-space" />

                    <ds-text-button
                        class="cancel-button"
                        data-qa="cancel-camp"
                        @click="modalClose"
                    >
                        Cancel
                    </ds-text-button>
                </div>
            </ds-modal>
        </div>
    </section>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        contact: Object,
    },

    data() {
        return {
            publishedCampaign: [],
            campaignFlows: [],
            selectedCampaign: 0,
            flowForCampaign: '',
            isSequenceModalOpen: false,
        };
    },

    created() {
        this.loadPublishedCampaign();
    },

    computed: {
        modelTitle() {
            return `Add ${this.contact.firstName} to Sequence`;
        },

        disableSave() {
            return Boolean(!this.flowForCampaign);
        },
    },

    methods: {
        showModal() {
            this.isSequenceModalOpen = true;
        },

        async loadPublishedCampaign() {
            try {
                const publishedCamp = await axios.get('/app/funnel/publishedCampaigns');

                this.publishedCampaign = Object.keys(publishedCamp.data).map((key) => {
                    return { label: publishedCamp.data[key], value: Number(key) };
                }).sort((prev, next) => prev.label.localeCompare(next.label));
            } catch (error) {
                this.$error({ message: 'Unable to get published Campaigns for this contact' });
            }
        },

        async getFlowsForCampaign() {
            try {
                const publishedCamp = await axios.get(`/app/addToSequenceFunnel/getFlowsForFunnel?funnelId=${this.selectedCampaign}`);

                this.campaignFlows = Object.keys(publishedCamp.data).map((key) => {
                    return { label: publishedCamp.data[key], value: Number(key) };
                }).sort((prev, next) => prev.label.localeCompare(next.label));
            } catch (error) {
                this.$error({ message: 'Unable to get published Campaigns for this contact' });
            }
        },

        selectedCampaignId() {
            this.getFlowsForCampaign();
        },

        modalClose() {
            this.isSequenceModalOpen = false;
            this.selectedCampaign = 0;
            this.flowForCampaign = 0;
        },

        async save() {
            try {
                const params = `contactId=${this.contact.id}&funnelId=${this.selectedCampaign}&flowId=${this.flowForCampaign}`;

                await axios.post(`/app/funnel/addContactToFunnel?${params}`);
                this.$root.$emit('LOAD_CAMP', true);
                this.modalClose();
            } catch (error) {
                this.$error({ message: 'Unable to get published Campaigns for this contact' });
            }
        },
    },
};
</script>

<style scoped>

</style>
